/* ------------------------------------------------------------------------------
@name: Reseller
--------------------------------------------------------------------------------- */

// --- variables
import { API_URL, BASE_URL } from "variables";

// --- utilities
import { DataTable, Form, HttpRequest, SweetAlert } from "utilities";
import { visible } from "ansi-colors";

// Form Validation
const ElementSelector = [
  {
    id: "reseller_id",
  },
  {
    id: "reseller_name",
    validation: {
      required: true,
    },
  },
  {
    id: "reseller_phone",
    validation: {
      required: true,
      phone: true,
      invalid: true,
    },
  },
];

const ElementEvents = ["input", "blur"];

const Reseller = (() => {
  // Handle Run DataTable
  const handleRunDataTable = () => {
    const dataSetting = {
      selector: "js-data-reseller",
      url: API_URL.resellerGet,
      method: "POST",
      responsive: {
        breakpoints: [
          { name: "desktop", width: Infinity },
          { name: "tablet", width: 1024 },
          { name: "mobile", width: 0 },
        ],
        details: {
          type: "column",
          target: 0,
        },
      },
    };

    const filterSetting = [
      {
        id: "dateRange",
        event: "change",
      },
      {
        id: "status",
        event: "change",
      },
      {
        id: "search",
        event: "keyup",
      },
    ];

    const columnSetting = [
      {
        targets: 0,
        className: "dt-control",
        orderable: false,
        data: null,
        defaultContent: "",
        responsivePriority: 1,
        visible: false,
      },
      {
        targets: 2,
        responsivePriority: 2,
      },
      {
        targets: [1, 3, 4, 5, 6],
        // className: "desktop-only",
        responsivePriority: 10000,
      },
      {
        targets: 7,
        responsivePriority: 1,
        className: "text-center",
        render: (data) => {
          let icon_status = data.status === "1" ? "ph-eye" : "ph-eye-slash";
          return `<div class="action-order"><button type="button" data-toggle="tooltip" data-placement="left" title="Status" class="btn btn-sm btn-default btn-trans waves-effect js-update-status" data-id="${data.id}" data-status="${data.status}"><i class="ph ${icon_status}"></i></button>
          <a href="${BASE_URL}reseller/detail/${data.id}" data-toggle="tooltip" data-placement="left" title="Detail" class="btn btn-sm btn-default btn-trans waves-effect js-detail-data" data-id="${data.id}"><i class="ph ph-magnifying-glass-plus"></i></a>
          <button type="button" data-toggle="tooltip" data-placement="left" title="Edit" class="btn btn-sm btn-default btn-trans waves-effect js-edit-data" data-id="${data.id}"><i class="ph ph-pencil-simple"></i></button>
					<button type="button" data-toggle="tooltip" data-placement="left" title="Delete" class="btn btn-sm btn-danger btn-trans waves-effect js-delete-data" data-id="${data.id}"><i class="ph ph-trash"></i></button></div>`;
        },
      },
    ];

    DataTable.custom(dataSetting, filterSetting, columnSetting);
  };

  // Handle Run Validation
  const handleRunValidation = () => {
    Form.validation(ElementEvents, ElementSelector);
  };

  // Handle Click Validation
  const handleClickValidation = () => {
    $('.js-form-reseller button[type="submit"]').on("click", (e) => {
      $.each(ElementSelector, (i, v) => {
        $("#" + v.id).blur();
      });

      if ($(".error").length === 0) {
        handlePostData();
      }
      e.preventDefault();
    });
  };

  // handleEmptyInput
  const handleEmptyInput = () => {
    $('.js-form-reseller button[data-dismiss="modal"]').on("click", (e) => {
      Form.emptyData(ElementSelector);
    });
  };

  // handlePostData
  const handlePostData = () => {
    const formData = Form.dataColletion(ElementSelector);

    let apiUrl = API_URL.resellerAdd;
    if ($("#reseller_id").val().length !== 0) {
      apiUrl = API_URL.resellerEdit;
    }

    const data = {
      url: apiUrl,
      method: "POST",
      data: formData,
      elementSelector: ElementSelector,
    };

    let response = HttpRequest.custom(data);

    if (response.code === 200) {
      $(".modal").modal("hide");
      Form.emptyData(ElementSelector);

      if ($(".js-form-order").length > 0) {
        $(".js-input-reseller").val(response.data.name);
        $(".js-input-reseller").attr("data-id", response.data.id);
      } else {
        SweetAlert.config(response.message, "success");
        $("#dataTable").DataTable().ajax.reload();
      }
    }
  };

  const handleGetFormData = () => {
    $("body").on("click", ".js-edit-data", (e) => {
      const _this = $(e.currentTarget);
      let formData = new FormData();
      const id = _this.attr("data-id");
      formData.append("reseller_id", id);

      const data = {
        url: API_URL.resellerGet,
        method: "POST",
        data: formData,
        elementSelector: ElementSelector,
      };

      Form.getFormData(data);
    });
  };

  // handleDeleteData
  const handleDeleteData = () => {
    $("body").on("click", ".js-delete-data", (e) => {
      const _this = $(e.currentTarget);
      let formData = new FormData();
      const id = _this.attr("data-id");
      console.log(id);

      formData.append("reseller_id", id);

      const data = {
        url: API_URL.resellerDelete,
        method: "POST",
        data: formData,
      };

      Form.deleteData(data);
    });
  };

  // handleUpdateStatus
  const handleUpdateStatus = () => {
    $("body").on("click", ".js-update-status", (e) => {
      console.log(1);
      const _this = $(e.currentTarget);
      let formData = new FormData();
      const id = _this.attr("data-id");
      let status = _this.attr("data-status");

      if (status == 0 || status == null) {
        status = 1;
      } else {
        status = 0;
      }

      formData.append("reseller_id", id);
      formData.append("status", status);
      const data = {
        url: API_URL.resellerEdit,
        method: "POST",
        data: formData,
      };
      Form.updateStatus(data);
    });
  };

  // handleSelectReseller
  const handleSelectReseller = () => {
    $(".js-input-reseller").on("input", (e) => {
      const _this = $(e.currentTarget);
      const _parent = _this.parent(".form-dropdown");
      const _val = _this.val();
      handlerGetReseller(_val);
    });

    $(".js-reset-dropdown").on("click", (e) => {
      const _this = $(e.currentTarget);
      const _parent = _this.parents(".form-dropdown");
      _parent.find("input").val("");
      _parent.find(".js-reset-dropdown").hide();
      _parent.find("input").focus();

      handlerGetReseller();
    });

    $(".js-input-reseller").on("focus", (e) => {
      $(e.currentTarget);
      handlerGetReseller();
    });
  };

  // handlerGetReseller
  const handlerGetReseller = (search = 0) => {
    $.ajax({
      url: API_URL.resellerGet,
      method: "POST",
      dataType: "JSON",
      data: {
        search: search,
      },
      success: (response) => {
        const _data = response.data;

        let _content = "";
        $.each(_data, (i, v) => {
          _content += `<li class="form-dropdown-item">
                          <span class="form-dropdown-select" data-value="${v.name}" data-id="${v.id}">
                            ${v.name}
                          </span>
                        </li>`;
        });

        if (_data.length === 0) {
          _content = `<li class="form-dropdown-notif">Data not found!</li>`;
        }

        $(".js-list-reseller").html(_content);
      },
    });
  };

  // init
  const init = () => {
    if ($(".js-data-reseller").length) {
      handleRunDataTable();
      handleDeleteData();
      handleGetFormData();
      handleUpdateStatus();
    }
    if ($(".js-form-reseller").length) {
      handleRunValidation();
      handleClickValidation();
      handleEmptyInput();
    }
    if ($(".js-list-reseller").length) {
      handleSelectReseller();
    }
  };

  return {
    init,
  };
})();

export default Reseller;
